import { useRouter } from 'next/router';
import style from './index.module.scss';

export interface IErrorPageProps {
  message: string;
  description: string;
  asset: string;
  url: string;
  actionWord: string;
}

ErrorPage.defaultProps = {
  message: ' Oops, Halaman Tidak Ditemukan',
  description: 'Kami meminta maaf tidak dapat menemukan halaman yang Anda cari',
  asset: `${process.env.CDN_URL}/images/main/mobile/halamannotfound-icon.webp`,
  url: '/',
  actionWord: 'KEMBALI',
};

export default function ErrorPage(props: IErrorPageProps) {
  const router = useRouter();
  return (
    <div className={style.wrapper}>
      <img
        src={props.asset}
        alt="illustration not-found"
        width="250"
        height="215.94"
      />
      <div className={style.message}>{props.message}</div>
      <div className={style.desciption}>{props.description}</div>
      <div
        className={style.buutton_reload}
        onClick={
          props.actionWord.toUpperCase() === 'REFRESH'
            ? () => {
                if (typeof window !== undefined) {
                  window.location.reload();
                }
              }
            : () => router.replace(props.url)
        }
      >
        <div className={style.action_word}>
          {props.actionWord.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
